import { initializeApp } from "firebase/app";
import { GoogleAuthProvider } from "firebase/auth";

// Your web app's Firebase configuration
const firebaseConfig = {
    apiKey: "AIzaSyCLZLDvMaEg4UR5TDiv-o2pDf-PEgCe87Y",
    authDomain: "insureboxdev-cc796.firebaseapp.com",
    projectId: "insureboxdev-cc796",
    storageBucket: "insureboxdev-cc796.appspot.com",
    messagingSenderId: "324579578073",
    appId: "1:324579578073:web:141c679339e8010c866ec8"
};

// Initialize Firebase
const firebaseApp = initializeApp(firebaseConfig);
export const googleProvider = new GoogleAuthProvider();
export default firebaseApp;



